import { render, staticRenderFns } from "./basicSkills.vue?vue&type=template&id=49f79d3e"
import script from "./basicSkills.vue?vue&type=script&lang=js"
export * from "./basicSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports